const isDataUrl = (url: string | null | undefined) => {
  return url && url.startsWith('data:');
};

export const urlUtils = {
  isDataUrl,
};
